import React from "react"
import { FloatingActionButton, Table, TableBody, TableRow, TableRowColumn } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import AppStateStore from "../../stores/AppStateStore"
import _ from "lodash"
import PunchQuestionDocDialog, { OpenPunchQuestionDocDialogMode } from "../../components/question/PunchQuestionDocDialog"
import { IPunchQuestion } from "../../models"
interface IProps {
    readonly?: boolean
    isRoot?: boolean
    overridden?: boolean
    settingObj?: IPunchQuestion
    handleChangeSettingObj?(settingObj: IPunchQuestion): void
}
interface IState {
    openPunchQuestionDocDialog: boolean
    openPunchQuestionDocDialogMode?: OpenPunchQuestionDocDialogMode
}

export default class HierarchySettingsPunchQuestions extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            openPunchQuestionDocDialog: false
        }
        autobind(this)
    }

    handleChangeValue(id: string) {
        const { settingObj } = this.props
        settingObj.Id = id
        this.props.handleChangeSettingObj(settingObj)
    }

    render() {
        const editable = this.props.isRoot || this.props.overridden
        const useSetting = this.props.settingObj && this.props.settingObj.Use ? true : false
        const parentHasQuestion = !this.props.overridden && useSetting
        const questionDocId = this.props.settingObj && this.props.settingObj.Id ? this.props.settingObj.Id : null
        return (
            <div>
                {!(this.props.readonly || !editable) && useSetting && !questionDocId &&
                    <FloatingActionButton
                        data-intercom-target={"menu-Hierarchy-Settings-PunchQuestions-Btn-Add"}
                        style={{ position: "absolute", top: -20, right: 42, zIndex: 100 }}
                        mini
                        secondary
                        onTouchTap={() => this.setState({ openPunchQuestionDocDialog: true, openPunchQuestionDocDialogMode: OpenPunchQuestionDocDialogMode.Add })}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                }
                {(this.props.isRoot ? useSetting : (this.props.overridden || parentHasQuestion)) &&
                    <Table
                        multiSelectable={false}
                        selectable={false}
                        fixedHeader={true}
                        style={{ backgroundColor: "none", borderBottom: "1px solid rgb(224,224,224)", borderTop: "1px solid rgb(224,224,224)" }}
                    >
                        <TableBody showRowHover={editable} deselectOnClickaway={false} displayRowCheckbox={false}>
                            <TableRow style={{ heigth: 45 }}>
                                <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                    {questionDocId ? strings.Question : strings.No_Question}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 60, cursor: "pointer" }} className="prevent-cell-click">
                                    <div onClick={e => e.stopPropagation()} style={{ float: "right" }}>
                                        {questionDocId &&
                                            <i
                                                data-intercom-target={"menu-Hierarchy-Settings-PunchQuestion-Btn-OpenViewQuestionsDialog"}
                                                className="fa fa-file-text-o"
                                                style={{ fontSize: 20, fontWeight: "bold", cursor: "pointer" }}
                                                onClick={() => this.setState({ openPunchQuestionDocDialog: true, openPunchQuestionDocDialogMode: OpenPunchQuestionDocDialogMode.View })}
                                            />
                                        }
                                        {!this.props.readonly && questionDocId && editable && [
                                            <i
                                                data-intercom-target={"menu-Hierarchy-Settings-PunchQuestion-Btn-OpenEditQuestionsDialog"}
                                                key="edit"
                                                className="fa fa-pencil"
                                                style={{ fontSize: 20, fontWeight: "bold", marginLeft: 10, cursor: "pointer" }}
                                                onClick={() => this.setState({ openPunchQuestionDocDialog: true, openPunchQuestionDocDialogMode: OpenPunchQuestionDocDialogMode.Edit })}
                                            />,
                                            <i
                                                data-intercom-target={"menu-Hierarchy-Settings-PunchQuestion-Btn-OpenRemoveQuestionDialog"}
                                                key="delete"
                                                className="fa fa-trash-o"
                                                style={{ fontSize: 20, fontWeight: "bold", marginLeft: 10, cursor: "pointer" }}
                                                onClick={() =>
                                                    AppStateStore.setConfirmDialogContent({
                                                        content: strings.Are_you_sure_you_want_to_delete_this_question,
                                                        confirm: () => this.handleChangeValue(null)
                                                    })
                                                }
                                            />
                                        ]}
                                    </div>
                                </TableRowColumn>
                            </TableRow>
                        </TableBody>
                    </Table>
                }
                {this.state.openPunchQuestionDocDialog &&
                    <PunchQuestionDocDialog
                        openPunchQuestionDocDialogMode={this.state.openPunchQuestionDocDialogMode}
                        questionDocId={questionDocId}
                        handleSave={questionDocId => this.setState({ openPunchQuestionDocDialog: false }, () => this.handleChangeValue(questionDocId))}
                        handleClose={() => this.setState({ openPunchQuestionDocDialog: false })}
                    />
                }
            </div>
        )
    }
}